import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { UserService } from '../../users/services/user.service';
import { UserAdminVerificationStatusEnum } from 'src/app/users/interfaces/user-values';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
              private userService: UserService,
              private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.authService.isAuthenticated()) {
        if (state.url === '/login') {
          this.router.navigate(['/lectures']);
          resolve(true);
        }
        if (!this.authService.isMailVerified()) {
          // if verification mail was not verified by user
          this.router.navigate(['/confirm-mail']);
          resolve(false);
        } else {

          this.userService.isAdmin().then((admin) => {
            if (admin) {
              resolve(true);
            } else {
              if (state.url.match('\/profile\/.+$')) {
                this.router.navigate(['/404']);
                resolve(false);
              }
              this.userService.getUserAdminVerificationStatus().then((status) => {
                if (status === UserAdminVerificationStatusEnum.PENDING) {
                  this.router.navigate(['/admin-verification']);
                  resolve(false);
                } else if (status === UserAdminVerificationStatusEnum.BLOCKED) {
                  this.router.navigate(['/user-blocked']);
                  resolve(false);
                } else {
                  resolve(true);
                }
              });
            }
          }).catch((err) => {
            console.error(err);
            resolve(false);
          });
        }
      } else {
        this.router.navigate(['/login']);
        resolve(false);
      }

    });
  }
}
